import { render, staticRenderFns } from "./ProductPerformanceByPercentageReport.vue?vue&type=template&id=657dc7c6&"
import script from "./ProductPerformanceByPercentageReport.vue?vue&type=script&lang=js&"
export * from "./ProductPerformanceByPercentageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports